function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 13.4 54.4",
    style: {
      enableBackground: "new 0 0 13.4 54.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {},
    cx: 6.7,
    cy: 6.4,
    r: 6.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {},
    cx: 6.7,
    cy: 27.1,
    r: 6.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {},
    cx: 6.7,
    cy: 47.9,
    r: 6.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParam);
export default __webpack_public_path__ + "static/media/param.1fd6a7e271c7ffe168a539037dbf50d9.svg";
export { ForwardRef as ReactComponent };